/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url)
      ? " menu-item-active menu-item-open "
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}


        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dash/customers")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/customers">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Add-user.svg")} />
            </span>
            <span className="menu-text">Users</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dash/redeems")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/redeems">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Dollar.svg")} />
            </span>
            <span className="menu-text">Redeems</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dash/offers")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/offers">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Wallet.svg")} />
            </span>
            <span className="menu-text">Completed Offers</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dash/rewards")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/rewards">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/ATM.svg")} />
            </span>
            <span className="menu-text">Manage Rewards</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

      {/*begin::1 Level*/}
      <li
          className={`menu-item ${getMenuItemActive("/dash/giveaway")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/giveaway">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")} />
            </span>
            <span className="menu-text">Giveaway</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
      <li
          className={`menu-item ${getMenuItemActive("/dash/notification")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/notification">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")} />
            </span>
            <span className="menu-text">Notification</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}


        {/* Setting */}
        {/* begin::section */}
        <li className="menu-section ">
          <h4 className="menu-text">Setting</h4>
          <i className="menu-icon flaticon-more-v2"></i>
        </li>
        {/* end:: section */}
      {/*begin::1 Level*/}
      <li
          className={`menu-item ${getMenuItemActive("/dash/network")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/network">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Settings.svg")} />
            </span>
            <span className="menu-text">Network</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
         {/*begin::1 Level*/}
      <li
          className={`menu-item ${getMenuItemActive("/dash/setting")}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dash/setting">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Settings.svg")} />
            </span>
            <span className="menu-text">App Setting</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
       
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
